/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractAssignmentHistoryEntry = {
  properties: {
    transactionId: {
      type: 'number',
    },
    time: {
      type: 'string',
      format: 'date-time',
    },
    statusBefore: {
      type: 'ReviewStatus',
    },
    statusAfter: {
      type: 'ReviewStatus',
    },
    reviewerName: {
      type: 'string',
    },
    action: {
      type: 'HistoryAction',
    },
    comment: {
      type: 'string',
    },
    reviewerType: {
      type: 'ContractReviewerType',
    },
    reviewAssignmentOrder: {
      type: 'number',
    },
    order: {
      type: 'string',
    },
  },
} as const;
